var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ServicesBillingBtn"},[(_vm.showBillingBtn)?_c('SplitButton',{staticClass:"blue",attrs:{"items":_vm.splitButtonItems},on:{"click":_vm.onBillingStep}},[_vm._v(_vm._s(_vm.billingStepText))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }